export default __webpack_public_path__ + "static/media/autonomy_yellow.24a07406.svg";